import styled from "styled-components";
import { useContext, useMemo } from "react";
import NavBar from "../../../Componentes/NavBar";
import BodyWrapper from "./BodyWrapper";
import { useModal } from "../../../contexts/ModalContext";
import SidebarBM from "./SidebarBM";
import { AuthContext } from "../../../Auth/AuthProvider";
import { VerifyPermission } from "../../../Funcoes/VerifyPermission";

const Container = styled.div`
    width: 100%;
    height: 100dvh;
    display: flex;
    flex-direction: column;
    background-color: #242d34;
`

const BoletimMedicao = () => {

    const { user } = useContext(AuthContext);
    const { isModalOpen, openModal } = useModal();

    const podeEmailsNF = useMemo(
        () =>
            VerifyPermission(user, {
                modulo: "controle-medicao",
                submodulo: "emails-nf",
                funcao: "gerenciar",
            }),
        [user]
    );

    const handleSidebarOpen = () => {
        openModal('sidebarBM');
    }

    return(
        <>
            <Container>
                <NavBar
                    navTo="/modulo/controle-medicao/pedidos-compra"
                    changeState={podeEmailsNF ? handleSidebarOpen : undefined}
                />
                <BodyWrapper />
            </Container>
            {
                isModalOpen('sidebarBM') && podeEmailsNF && (
                    <SidebarBM />
                )
            }
        </>
    )
}

export default BoletimMedicao;